
    import './styles.scoped.css';
    export default {
  "label": "awsui_label_1f1d4_ocied_5"
};
  